import React from "react";

const segmentos = [
  "Sementes",
  "Fertilizantes",
  "Adjuvantes, Biológicos e Micros",
  "Combustíveis",
  "Peças e Implementos",
  "Agropecuárias",
  "Revendas",
  "Corretoras de Grãos",
];

const Categorias: React.FC = () => (
  <section className="border-b border-bone-300 bg-white">
    <div className="mx-auto max-w-site px-5 py-16 lg:px-8 lg:py-24">
      <div className="max-w-2xl">
        <p className="eyebrow">Segmentos da plataforma</p>
        <h2 className="mt-4 font-display text-display-md font-bold text-soil">
          De alfinete a foguete.
        </h2>
        <p className="mt-5 text-lg leading-relaxed text-soil/75">
          Tudo o que a fazenda precisa comprar, e também a corretora para
          negociar o que ela produz. Cada empresa cadastrada publica o próprio
          catálogo, então o que aparece para você depende de quem atende a sua
          região.
        </p>
      </div>

      <ul className="mt-12 grid gap-px border border-bone-300 bg-bone-300 sm:grid-cols-2 lg:grid-cols-4">
        {segmentos.map((nome) => (
          <li
            key={nome}
            className="flex min-h-[7rem] items-end bg-white p-5 lg:min-h-[8.5rem] lg:p-6"
          >
            <h3 className="font-display text-lg font-bold leading-tight text-soil lg:text-xl">
              {nome}
            </h3>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default Categorias;
